/**
 * The sidecar subtitle formats of an export (1.9.0): SRT, WebVTT, TTML (IMSC 1.1) and EBU-TT-D, at least one; SRT and
 * WebVTT by default, as before. The dialogs send the choice as `sidecarFormats` (left out when it is the default).
 */
import { DEFAULT_SIDECAR_FORMATS, SIDECAR_FORMATS, SIDECAR_LABELS, type SidecarFormat } from '@prism/contracts';

/** The request field: undefined for the default (SRT and WebVTT), else the formats in their usual order. */
export function sidecarFormatsField(value: readonly SidecarFormat[]): SidecarFormat[] | undefined {
  const v = SIDECAR_FORMATS.filter((f) => value.includes(f));
  if (!v.length) return undefined;
  const isDefault = v.length === DEFAULT_SIDECAR_FORMATS.length && v.every((f) => DEFAULT_SIDECAR_FORMATS.includes(f));
  return isDefault ? undefined : v;
}

export function SidecarFormats({ value, onChange, testId = 'sidecar-formats', disabled }: {
  value: readonly SidecarFormat[]; onChange: (next: SidecarFormat[]) => void; testId?: string; disabled?: boolean;
}) {
  return (
    <div className="field" data-testid={testId}>
      <span className="field-label" id={`${testId}-label`}>Sidecar files</span>
      <div className="toggles" role="group" aria-labelledby={`${testId}-label`}>
        {SIDECAR_FORMATS.map((f) => {
          const on = value.includes(f);
          return (
            <label key={f}>
              <input type="checkbox" checked={on} disabled={disabled || (on && value.length === 1)} data-format={f} data-testid={`${testId}-${f}`}
                onChange={(e) => onChange(SIDECAR_FORMATS.filter((x) => (x === f ? e.target.checked : value.includes(x))))} />
              {SIDECAR_LABELS[f]}
            </label>
          );
        })}
      </div>
      <span className="help">SRT and WebVTT keep the placement and colour; background and size are kept in the TTML files only.</span>
    </div>
  );
}
